import { render, staticRenderFns } from "./stadium_scroll.vue?vue&type=template&id=56d711a7&"
import script from "./stadium_scroll.vue?vue&type=script&lang=ts&"
export * from "./stadium_scroll.vue?vue&type=script&lang=ts&"
import style0 from "./stadium_scroll.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports